import { useQuery } from 'react-query';

import { QUERY_KEYS } from '../constants';
import { fetchDestinations } from '../request';

export const useFetchDestinations = (isOpen: boolean) => {
  const { isLoading, data, error } = useQuery({
    queryKey: [QUERY_KEYS.GET_DESTINATIONS],
    queryFn: fetchDestinations,
    enabled: isOpen,
  });

  return { data: data ?? [], isLoading, error };
};
